import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { authFetch } from "../../auth";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faCog,
  faHome,
  faSearch,
  faEllipsisH,
  faEye,
  faEdit,
  faTrashAlt,
  faHandSparkles,
  faEnvelope,
  faUnlockAlt,
  faUser,
  faUserAltSlash,
} from "@fortawesome/free-solid-svg-icons";
import {
  Col,
  Row,
  Form,
  Button,
  ButtonGroup,
  Breadcrumb,
  InputGroup,
  Dropdown,
  Container,
  Card,
  Pagination,
  Table,
  Nav,
  Modal,
} from "@themesberg/react-bootstrap";
import { Routes } from "../../routes";
import { FormattedMessage } from "react-intl";
import {
  UserEditModal,
  DeleteSuccessModal,
  CreateUserModal,
} from "../../components/Modal";

const ActiveModal = ({ id }) => {
  console.log(id);
  return (
    <Modal as={Modal.Dialog} centered show>
      <Modal.Header>
        <Modal.Title className="h5">성공</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          <FormattedMessage id={id || "foramteddMessage error"} />
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={() => {
            window.location.reload();
          }}
          variant="secondary"
        >
          확인
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const TableRow = ({ item, setActiveSuccess, setMsgId }) => {
  const {
    id,
    username,
    email,
    active,
    registered_at,
    confirmed_at,
    companyName,
  } = item;
  const activeStatus = active === true ? "O" : "X";
  const [edit, setEdit] = useState(false);
  const [show, setShow] = useState(false);

  const onButtonClick = (evt) => {
    authFetch(process.env.REACT_APP_API_URL + "/api/admin/user/activate", {
      method: "POST",
      body: JSON.stringify({
        email,
        state: active,
      }),
    }).then((resp) => {
      let msg_id;
      active ? (msg_id = "deactSuccess") : (msg_id = "actSuccess");

      if (resp.status === 200) {
        setActiveSuccess();
        setMsgId(msg_id);
      } else if (resp.status === 401) {
        setActiveSuccess();
        setMsgId("deactFail");
      } else {
        console.log("error occurred!");
      }
    });
  };

  const onDeleteClick = (evt) => {
    authFetch(process.env.REACT_APP_API_URL + `/api/admin/user/${id}`, {
      method: "DELETE",
    }).then((resp) => {
      if (resp.status === 200) {
        setShow(true);
      }
    });
  };

  return (
    <tr>
      {edit && (
        <UserEditModal
          user={item}
          onCancel={() => {
            setEdit((prev) => !prev);
          }}
        />
      )}
      {show && <DeleteSuccessModal />}
      <td>{id}</td>
      <td>
        <span className="fw-normal">{username}</span>
      </td>
      <td>
        <span className="fw-normal">{email}</span>
      </td>
      <td>
        <span className="fw-normal">{activeStatus}</span>
      </td>
      <td>
        <span className="fw-normal">{registered_at}</span>
      </td>

      <td>
        <span className="fw-normal">{confirmed_at}</span>
      </td>
      <td>
        <span className="fw-normal">{companyName}</span>
      </td>
      <td>
        <Dropdown as={ButtonGroup}>
          <Dropdown.Toggle
            as={Button}
            split
            variant="link"
            className="text-dark m-0 p-0"
          >
            <span className="icon icon-sm">
              <FontAwesomeIcon icon={faEllipsisH} className="icon-dark" />
            </span>
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item
              className="text-success"
              name="userEdit"
              onClick={() => {
                setEdit((prev) => !prev);
              }}
            >
              <FontAwesomeIcon icon={faEdit} className="me-2" />{" "}
              <FormattedMessage id="toEdit" />
            </Dropdown.Item>
            {active ? (
              <Dropdown.Item className="text-warning" onClick={onButtonClick}>
                <FontAwesomeIcon icon={faUserAltSlash} className="me-2" />{" "}
                <FormattedMessage id="deactivate" />
              </Dropdown.Item>
            ) : (
              <Dropdown.Item className="text-success" onClick={onButtonClick}>
                <FontAwesomeIcon icon={faHandSparkles} className="me-2" />{" "}
                <FormattedMessage id="activate" />
              </Dropdown.Item>
            )}

            <Dropdown.Item className="text-danger" onClick={onDeleteClick}>
              <FontAwesomeIcon icon={faTrashAlt} className="me-2" />{" "}
              <FormattedMessage id="toDelete" />
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </td>
    </tr>
  );
};

const TransactionsTable = ({ transactions }) => {
  const totalTransactions = transactions.length;
  const [activeSuccess, setActiveSuccess] = useState(false);
  const [msgId, setMsgId] = useState("");

  return (
    <Card border="light" className="table-wrapper table-responsive shadow-sm">
      <Card.Body className="pt-0">
        <Table hover className="user-table align-items-center">
          <thead>
            <tr>
              <th className="border-bottom">#</th>
              <th className="border-bottom">Username</th>
              <th className="border-bottom">Email</th>
              <th className="border-bottom">Active</th>
              <th className="border-bottom">Registered at</th>
              <th className="border-bottom">Confirmed at</th>
              <th className="border-bottom">Company Name</th>
              <th className="border-bottom"></th>
            </tr>
          </thead>
          <tbody>
            {transactions.map((user) => (
              <TableRow
                key={user.id}
                item={user}
                setActiveSuccess={() => setActiveSuccess(true)}
                setMsgId={(id) => {
                  setMsgId(id);
                }}
              />
            ))}
          </tbody>
        </Table>
        {activeSuccess && <ActiveModal id={msgId} />}
        <Card.Footer className="px-3 border-0 d-lg-flex align-items-center justify-content-between">
          <small className="fw-bold">
            Showing <b>{totalTransactions}</b> out of <b>{totalTransactions}</b>{" "}
            entries
          </small>
        </Card.Footer>
      </Card.Body>
    </Card>
  );
};

export default () => {
  const [userList, setUserList] = useState([]);
  const [show, setShow] = useState(false);

  useEffect(() => {
    authFetch(process.env.REACT_APP_API_URL + "/api/admin/user")
      .then((resp) => resp.json())
      .then((resp) => {
        setUserList(resp);
      });
  }, []);

  return (
    <Container fluid>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-md-0">
          <Breadcrumb
            className="d-none d-md-inline-block"
            listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}
          >
            <Breadcrumb.Item>
              <FontAwesomeIcon icon={faHome} />
            </Breadcrumb.Item>
            <Breadcrumb.Item>Admin</Breadcrumb.Item>
            <Breadcrumb.Item active>Managing Users</Breadcrumb.Item>
          </Breadcrumb>
          <h4>Users</h4>
          <p className="mb-0">Your web analytics dashboard template.</p>
        </div>
        <div className="btn-toolbar mb-2 mb-md-0">
          <Button
            onClick={() => {
              setShow((prev) => !prev);
            }}
          >
            <FormattedMessage id="toCreate" />
          </Button>
        </div>
      </div>
      {show && (
        <CreateUserModal
          onCancel={() => {
            setShow((prev) => !prev);
          }}
        />
      )}
      <TransactionsTable transactions={userList} />
    </Container>
  );
};
